import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const paymentRouter: RouteConfig = {
  path: "/payment",
  name: "payment",
  component: Layout,
  meta: {
    title: "会员",
    icon: "vip",
    permission: "Pages.Payment"
  },
  children: [
    {
      path: "payment-statics",
      name: "PaymentStatics",
      component: () =>
        import(/* webpackChunkName: "user" */ "@/views/payment/payment-statics/index.vue"),
      meta: {
        title: "会员统计",
        permission: "Pages.Payment"
      }
    },
    {
      path: "payment-payments",
      name: "Payments",
      component: () =>
        import(/* webpackChunkName: "user" */ "@/views/payment/payment-payments/index.vue"),
      meta: {
        title: "会员列表",
        permission: "Pages.Payment.Payments"
      }
    },
    {
      path: "payment-payments/vip-payment-record/:id",
      name: "vipPaymentRecord",
      component: () =>
        import(/* webpackChunkName: "update-role" */ "@/views/payment/payment-payments/vip-payment-record.vue"),
      meta: {
        title: "充值记录",
        hidden: true
      }
    },
    {
      path: "payment-payments/payment-detail/:id",
      name: "PaymentDetail",
      component: () =>
        import(/* webpackChunkName: "update-role" */ "@/views/payment/payment-payments/payment-detail.vue"),
      meta: {
        title: "会员详情",
        hidden: true
      }
    },

    {
      path: "payment-payments/order-detail/:id",
      name: "OrderDetail",
      component: () =>
        import(/* webpackChunkName: "update-role" */ "@/views/payment/payment-payments/order-detail.vue"),
      meta: {
        title: "订单详情",
        hidden: true
      }
    },
    {
      path: "payment-orders",
      name: "Orders",
      component: () =>
        import(/* webpackChunkName: "user" */ "@/views/payment/payment-orders/index.vue"),
      meta: {
        title: "会员订单列表",
        //permission: "Pages.Payment.Orders1"
      }
    }
  ]
};

export default paymentRouter;
